import React, { memo } from 'react';
import { useInView } from 'react-intersection-observer';

import useNativeLazyLoading from 'hooks/useNativeLazyLoading';
import './styles.scss';

interface IImage {
  src: string;
  className?: string;
  onClick?: () => void;
}

const Image: React.FC<IImage> = ({ src, className, onClick }) => {
  const hasNativeLazy = useNativeLazyLoading();
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px',
    skip: hasNativeLazy,
    fallbackInView: true,
  });

  return (
    <div className={`image-container ${className ?? ''}`} ref={ref}>
      {inView || hasNativeLazy ? (
        <img
          alt=""
          src={src}
          loading="lazy"
          onClick={onClick}
        />
      ) : null}
    </div>
  );
};

export default memo(Image);
